var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDarkOrbit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 402 401"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "75.016%",
    y1: "6.671%",
    x2: "24.998%",
    y2: "93.307%",
    id: "dark-orbit_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#646A7E",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1932",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "url(#dark-orbit_svg__a)",
    fillRule: "nonzero",
    opacity: 0.4,
    cx: 199.954,
    cy: 197.403,
    r: 132.346
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "url(#dark-orbit_svg__a)",
    fillRule: "nonzero",
    opacity: 0.4,
    cx: 199.954,
    cy: 197.403,
    r: 106.196
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#7C8E9B",
    strokeWidth: 0.667,
    cx: 199.954,
    cy: 197.403,
    r: 132.346
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#7C8E9B",
    strokeWidth: 0.667,
    cx: 199.954,
    cy: 199.636,
    rx: 199.954,
    ry: 199.636
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5F6B7C",
    fillRule: "nonzero",
    cx: 373.759,
    cy: 100.774,
    r: 3.827
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5F6B7C",
    fillRule: "nonzero",
    cx: 332.301,
    cy: 197.722,
    r: 4.465
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5F6B7C",
    fillRule: "nonzero",
    cx: 332.938,
    cy: 348.246,
    r: 4.465
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5F6B7C",
    fillRule: "nonzero",
    cx: 97.904,
    cy: 281.595,
    r: 3.508
  }))));
}

export default "data:image/svg+xml;base64,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";
export { SvgDarkOrbit as ReactComponent };